const Promise = require('es6-promise').Promise;
const Browser = require('../../models/environ/browser');
const { getBgImg } = require('../modules/element-state');

/**
 * PreloadImage
 * @class
 */
class PreloadImage {

  /**
   * @static
   * @prop {array} images data
   */
  static data = [];

  /**
   * @instance
   * @param _$el {HTMLElement}
   * @param _otherImages {array} images path
   */
  constructor(_$el, _otherImages = []) {
    this.$el     = _$el;
    this.images = _otherImages;
    this.loaded = 0;

    const browser_ = Browser.getInstance();

    if( typeof browser_ !== 'undefined' && browser_ !== null ) {
      this.isIE9Below = ( browser_.msie && (10 > browser_.versionNumber) ) ? true : false;
    }

    const images_ = _.map(this.$el.getElementsByTagName('img'), (_img) => {
      return _img.src;
    });

    const bgImages_ = _.compact(_.map(this.$el.getElementsByTagName('*'), (_$el) => {
      return getBgImg(_$el);
    }));
    const bgImg_ = getBgImg(this.$el);
    if(bgImg_) bgImages_.push(bgImg_)

    const svgImages_ = _.compact(_.map(this.$el.getElementsByTagName('image'), (_$el) => {
      return _$el.getAttribute('xlink:href');
    }));

    const data_ = _.map(PreloadImage.data, 'src');
    this.images = _.union(this.images, images_, bgImages_, svgImages_);
    this.images = _.difference(this.images, data_);
  }

  /**
   * @instance
   */
  load() {
    return Promise.all(_.map(this.images, (_src) => {
      return new Promise( (_resolve) => {

        const img_ = new Image();

        const loadend_ = () => {
          this.loaded++;
          _resolve();
        };

        const success_ = () => {
          PreloadImage.data.push({
            src   : img_.src,
            width : img_.width,
            height: img_.height,
          });
        };

        if(!this.isIE9Below) {
          img_.onload = () => {
            success_();
            loadend_();
          };
          img_.onerror = () => {
            loadend_();
          };
        } else {
          const timer_ = () => {
            setTimeout( () => {
              if(img_.width){
                success_();
                loadend_();
              } else {
                timer_();
              }
            }, 100);
          };
          timer_();
        }

        img_.src = _src;

      });

    }));
  }

}

/**
 * class exports
 */
module.exports = PreloadImage;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/request/preload-image.js
 **/